import React from "react";

import RiderLegalAccept from "../legal/RiderLegalAccept";

export default function RiderLegalAcceptRoute() {
  return <RiderLegalAccept />;
}
